/* eslint-disable dot-notation */
import axios from 'axios';

const apiAuthClient = axios.create({
  baseURL: `${process.env.VUE_APP_CALCULATOR_API_URL}api/v1/carbon-calculator`,
  headers: {
    'Content-Type': 'application/json',
    ENV: process.env.VUE_APP_ENV,
    APIKey: process.env.VUE_APP_API_KEY,
    Authorization: null
  }
});

export default {
  post (url, payload, accessToken) {
    if (!accessToken) {
      accessToken = payload;
      payload = {};
    }
    apiAuthClient.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
    return apiAuthClient.post(url, payload);
  },
  put (url, payload, accessToken) {
    apiAuthClient.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
    return apiAuthClient.put(url, payload);
  },
  get (url, accessToken) {
    apiAuthClient.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
    return apiAuthClient.get(url);
  }
};
